import {
  Box,
  // Box,
  Flex,
  // Grid, GridItem, Text
} from '@chakra-ui/layout';
import { Modal, ModalBody, ModalContent } from '@chakra-ui/react';
import React, { useEffect } from 'react';

// import grandWinnerImage from './images/grand-winner.png';
// import megaWinnerImage from './images/mega-winner.png';
// import ultimateWinnerImage from './images/ultimate-winner.png';
// import { MailChimpEmailSubscribe } from './MailChimpEmailSubscribe';
import { lightsOn, PrizeType } from './utils';

// import coinsGrandWin from './videos/coins-grand-win.mov';
// import goldFireworks from './videos/gold-fireworks.mov';
// import sunburst from './videos/sunburst.mov';

interface StartModalProps {
  isOpen: boolean;
  onClose: () => void;
  prizeResult: PrizeType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // biome-ignore lint/suspicious/noExplicitAny: migrated from develop
  playFireworks: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // biome-ignore lint/suspicious/noExplicitAny: migrated from develop
  stopFireworks: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // biome-ignore lint/suspicious/noExplicitAny: migrated from develop
  playCoinsFall: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // biome-ignore lint/suspicious/noExplicitAny: migrated from develop
  [key: string]: any;
}

const WinnerModal = ({
  isOpen,
  onClose,
  containerRef,
  prizeResult,
  playFireworks,
  stopFireworks,
  playCoinsFall,
}: StartModalProps) => {
  const [showGrandFireworks, setShowGrandFireworks] = React.useState(false);
  // biome-ignore lint/correctness/useExhaustiveDependencies: intentional dependency list
  useEffect(() => {
    if (prizeResult === PrizeType.GRAND && isOpen) {
      playCoinsFall();
      lightsOn(true);
      setTimeout(() => {
        setShowGrandFireworks(true);
        playFireworks();
      }, 4200);
    }
    return () => {
      setShowGrandFireworks(false);
      stopFireworks();
      lightsOn(false);
    };
  }, [isOpen, prizeResult]);
  return (
    <Modal
      onClose={onClose}
      size="full"
      isCentered
      isOpen={isOpen}
      portalProps={{ appendToParentPortal: true, containerRef }}
    >
      <ModalContent h="100%" maxH="100%" maxW="100%" background="none">
        <ModalBody
          background="rgba(0, 0, 255, 0)"
          h="100%"
          p={0}
          position="relative"
        >
          {prizeResult === PrizeType.GRAND && (
            <video
              // ref={videoRef}
              src="http://localhost:3001/videos/coins-grand-win.mov"
              autoPlay
              // loop
              playsInline
              muted
              style={{
                zIndex: 100,
                objectFit: 'cover',
                width: '100vw',
                height: '100vh',
                position: 'fixed',
                top: 0,
                left: 0,
              }}
            />
          )}
          {prizeResult === PrizeType.GRAND && showGrandFireworks && (
            <>
              <video
                // ref={videoRef}
                src="http://localhost:3001/videos/gold-fireworks.mov"
                autoPlay
                loop
                playsInline
                muted
                style={{
                  zIndex: 20,
                  objectFit: 'cover',
                  width: '100vw',
                  height: '100vh',
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  opacity: 0.8,
                  // background: 'rgba(150, 0, 0, 0.9)',
                  // mixBlendMode: 'plus-lighter',
                }}
              />
              <video
                // ref={videoRef}
                src="http://localhost:3001/videos/sunburst.mov"
                autoPlay
                loop
                playsInline
                muted
                style={{
                  zIndex: 30,
                  objectFit: 'cover',
                  width: '100vw',
                  height: '100vh',
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  // opacity: 0.8,
                  // background: 'rgba(150, 0, 0, 0.9)',
                  mixBlendMode: 'plus-lighter',
                }}
              />
              <Flex
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                h="full"
                zIndex={31}
                position="relative"
              >
                <img
                  src="http://localhost:3001/images/grand-winner.png"
                  alt=""
                />
              </Flex>
            </>
          )}
          {prizeResult === PrizeType.MEGA && (
            <Box h="full" w="full" backgroundColor="rgba(4, 32, 85, 1)">
              <video
                // ref={videoRef}
                src="http://localhost:3001/videos/sunburst.mov"
                autoPlay
                loop
                playsInline
                muted
                style={{
                  zIndex: 32,
                  objectFit: 'cover',
                  width: '100vw',
                  height: '100vh',
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  // opacity: 0.8,
                  // background: 'rgba(150, 0, 0, 0.9)',
                  mixBlendMode: 'color-dodge',
                }}
              />
              <Flex
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                h="full"
                zIndex={33}
                position="relative"
                // backgroundColor="rgba(4, 32, 85, 1)"
              >
                <img
                  src="http://localhost:3001/images/mega-winner.png"
                  alt=""
                />
              </Flex>
            </Box>
          )}
          {prizeResult === PrizeType.ULTIMATE && (
            <Box h="full" w="full" backgroundColor="rgba(4, 50, 11, 1)">
              <video
                // ref={videoRef}
                src="http://localhost:3001/videos/sunburst.mov"
                autoPlay
                loop
                playsInline
                muted
                style={{
                  zIndex: 32,
                  objectFit: 'cover',
                  width: '100vw',
                  height: '100vh',
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  // opacity: 0.8,
                  // background: 'rgba(150, 0, 0, 0.9)',
                  mixBlendMode: 'color-dodge',
                }}
              />
              <Flex
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                h="full"
                zIndex={33}
                position="relative"
                // backgroundColor="rgba(4, 50, 11, 1)"
              >
                <img
                  src="http://localhost:3001/images/ultimate-winner.png"
                  alt=""
                />
              </Flex>
            </Box>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default WinnerModal;
